import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import Popup from '../Popup';
import { commonStyles, COLORS } from '../../styles/styles';

const PagePopup = ({ classes, handlePopupToggle, title, markup }) => (
  <Popup>
    <div className={classes.popup}>
      <div className={classes.popupIframe}>
        <div className={classes.popupHeader}>
          <Clear className={classes.closePopup} onClick={handlePopupToggle} />
        </div>
        <div className={classes.iframeContainer}>
          <Typography className={classes.title}>{title}</Typography>
          <div className={classes.content} dangerouslySetInnerHTML={{ __html: markup }} /> {/* eslint-disable-line */}
        </div>
      </div>
    </div>
  </Popup>
);

const styles = () => ({
  ...commonStyles,
  image: {
    margin: '0 auto',
    display: 'block',
    maxWidth: 1200,
    width: '98%',
  },
  title: {
    fontSize: 24,
    margin: 40,
    fontWeight: 'bold',
  },
  content: {
    margin: '0 40px',
    '&> *': {
      color: '#fff',
      fontFamily: 'Roboto',
      textAlign: 'justify',
    },
  },
  iframeContainer: {
    position: 'relative',
    background: COLORS.grey,
    overflow: 'scroll',
    height: 'calc(100% - 64px)',
  },
  popupIframe: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 10,
  },
  popupHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 64,
  },
  closePopup: {
    color: '#fff',
    background: 'transparent',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    margin: '20px 15px 0 0',
  },
});

export default compose(withStyles(styles))(PagePopup);

PagePopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handlePopupToggle: PropTypes.func,
  markup: PropTypes.string,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/Components/Popups/PagePopup.jsx